"use client";

import styles from "./SearchPage.module.css";
import { RichTextRender } from "@/components/ui/RichTextRender";
import type { StoryblokRichtext } from "@/storyblok-base";
import { withSearchParams } from "@/components/withSearchParams";
import { SearchTabs } from "./SearchTabs";

interface SearchHeaderProps {
	title?: string;
	description?: StoryblokRichtext | string;
	preview: boolean;
	counts?: {
		products?: number;
		articles?: number;
		categories?: number;
	};
}

export const SearchHeader = withSearchParams<SearchHeaderProps>(
	({ title, description, preview, counts, searchParams }) => {
		const query = searchParams.get("q") || "";
		return (
			<div className={styles.header}>
				<h1 className={styles.title}>
					{title?.replace("{{query}}", Array.isArray(query) ? query[0] : query || "")}
				</h1>
				{counts && <SearchTabs counts={counts} />}
				<RichTextRender blok={description!} preview={preview} />
			</div>
		);
	},
);
